import { Button, Icon } from "@/components";
import { BUTTON } from "@/components/Styles/variants";
import useJob from "@/modules/hooks/useJob";
import { useModals } from "react-easy-modals";
import { getJobReopenUrl } from "@/utils";
import polyglot from "@/utils/polyglot";
import { useCallback } from "react";
import RecurringJobsDiscoverModal from "../recurring-jobs/RecurringJobsDiscoverModal";
import { getPaidOffers } from "./utils";

const AskJobAgainButton = () => {
  const { data } = useJob();
  const modals = useModals();

  const canOpenRecurringJobsDiscoverModal = useCallback(() => {
    const offer = getPaidOffers(data.accepted_offers)?.[0];
    return data.eligible_for_recurrence && offer;
  }, [data.eligible_for_recurrence, data.accepted_offers]);

  const getJobUrl = () =>
    getJobReopenUrl({
      id: data.id,
      category: data.category,
      offers: data.accepted_offers,
      nbJobbers: data.nb_jobbers,
    });

  const handleOpenAskAgainModal = () => {
    const offer = getPaidOffers(data.accepted_offers)?.[0];
    if (canOpenRecurringJobsDiscoverModal()) {
      modals.open(RecurringJobsDiscoverModal, {
        jobber: offer.jobber,
        refuseUrl: getJobUrl(),
      });
    }
  };

  if (!data.can_duplicate_job) return null;
  return (
    <Button.Medium
      block
      kind={BUTTON.KIND.TERTIARY}
      onClick={handleOpenAskAgainModal}
      href={!canOpenRecurringJobsDiscoverModal() ? getJobUrl() : undefined}
      RightComponent={() => <Icon.Large name="copy" />}
    >
      {polyglot.t("jobs.ask_again")}
    </Button.Medium>
  );
};

export default AskJobAgainButton;
